import { BaseDisplayer } from './Displayers/BaseDisplayer';
import { BaseParser } from './Parsers/BaseParser';
import { BaseValidator } from './Validators/BaseValidator';

export enum ParseResult {
  UNDEFINED = -2,
  WARNING = -1,
  OK = 0,
  ERROR = 1,
  ERROR_PATTERN = 2,
  ERROR_BELOWMIN = 13,
  ERROR_ABOVEMAX = 14,
  ERROR_BELOWRANGE = 15,
  ERROR_ABOVERANGE = 16,

  ERROR_BELOWMINTIME = 21,
  ERROR_ABOVEMAXTIME = 22,
  ERROR_BELOWRANGETIME = 23,
  ERROR_ABOVERANGETIME = 24,

  ERROR_BELOWMINDATETIME = 25,
  ERROR_ABOVEMAXDATETIME = 26,
  ERROR_BELOWRANGEDATETIME = 27,
  ERROR_ABOVERANGEDATETIME = 28,

  ERROR_PN_NUMBERMISSING = 30,
  ERROR_ON_INVALIDCONTROLDIGIT = 31,
  ERROR_ON_ORGINVALIDCONTROLDIGIT = 41,

  WARNING_BELOWMIN = -11,
  WARNING_ABOVEMAX = -12,
  WARNING_BELOWRANGE = -13,
  WARNING_ABOVERANGE = -14,

  WARNING_BELOWMINTIME = -21,
  WARNING_ABOVEMAXTIME = -22,
  WARNING_BELOWRANGETIME = -23,
  WARNING_ABOVERANGETIME = -24,

  WARNING_BELOWMINDATETIME = -25,
  WARNING_ABOVEMAXDATETIME = -26,
  WARNING_BELOWRANGEDATETIME = -27,
  WARNING_ABOVERANGEDATETIME = -28,

  WARNING_USERDEFINED = -100,
}

export enum PreParseResult {
  UNDEFINED = -2,
  OK = 0,
}

export enum PreParseDateTimeOrigin {
  ppdoNone,
  ppdoAr,
  ppdoMan,
  ppdoDatum,
  ppdoV,
  ppdoTim,
  ppdoMin,
  ppdoMa,
  ppdoTi,
  ppdoOn,
  ppdoTo,
  ppdoFr,
  ppdoLo,
  ppdoSo,
}

export enum PreParseDateTimeValueType {
  ppdvNone,
  ppdvAr,
  ppdvMan,
  ppdvDag,
  ppdvV,
  ppdvTim,
  ppdvMin,
}

export type Alignment = 'taLeftJustify' | 'taRightJustify' | 'taCenter';
export enum TEDParseNumberMode {
  pnmInteger,
  pnmInt64,
  pnmFloat,
  pnmCurrency,
  pnmPercent,
  pnmDegrees,
}

// (pdmGeneral, pdmYMD, pdmYM, pdmY, pdmHMS, pdmHM, pdmH, pdmYMDHM, pdmYW, pdmString);
export enum TEDParseDateTimeMode {
  pdmGeneral,
  pdmYMD,
  pdmYM,
  pdmY,
  pdmHMS,
  pdmHM,
  pdmH,
  pdmYMDHM,
  pdmYW,
  pdmDateString,
  pdmDateTimeString,
}

export type ValueType = number | string | boolean | null | undefined;

export enum CaseOption {
  upper,
  lower,
  firstUpper,
  firstLower,
  words,
  paragraphs,
  persNames,
  orgNames,
  streetNames,
}

export interface IParseResult {
  value: ValueType;
  result: ParseResult | PreParseResult;
  preFix?: string;
}

export interface IFormatter {
  displayer: BaseDisplayer;
  parser: BaseParser;
  validator: BaseValidator;
}

export class ParseError extends Error {}

export class ValidateError extends Error {}

// export interface IParser {
//   defaultParams: () => string;
//   parse: (text: string, params?: string) => IParseResult;
//   maxLength: (params?: string) => number;
//   validateKey: (key: string, params?: string) => boolean;
//   hasPreparser: () => boolean;
//   preParse: (text: string, params?: string) => IParseResult;
//   errorMessage: (
//     text: string,
//     parseResult: IParseResult,
//     params?: string,
//     caption?: string
//   ) => string;
//   validateChars: (s: string, params?: string) => string; // Osäker, s är en VAR i delphi
//   raiseError: (
//     text: string,
//     parseResult: IParseResult,
//     params?: string,
//     caption?: string,
//     sender?: string,
//     unitName?: string,
//     procName?: string
//   ) => void;
//   checkParse: (
//     text: string,
//     params?: string,
//     caption?: string,
//     sender?: string,
//     unitName?: string,
//     procName?: string
//   ) => any;
//   parseDef: (text: string, defaultValue: any, params?: string) => any;
// }

// export interface IDisplayer {
//   defaultParams: () => string;
//   display: (value: any, displayText?: boolean, params?: string) => string;
//   defaultDisplayLength: (params?: string) => number;
//   alignment: (params?: string) => Alignment;
//   preDisplay: (value: any, displayText?: boolean, params?: string) => string;
// }

// export interface IConverter {
//   defaultParams: () => string;
//   convertToInternalValue(value: any, params?: string): any;
//   convertToValue(internalValue: any, params?: string): any;
// }
